import type { StepDefinition } from "@/shared/components/common/PropertyStepperScreen";
import type { LocalSupportingDocumentItem } from "@/features/protest/services/localSupportingDocuments.service";
import { CommercialAppraisalStepPage } from "./commercial/CommercialAppraisalStepPage";
import { CommercialFutureExpendituresStepPage } from "./commercial/CommercialFutureExpendituresStepPage";
import { CommercialIncomeExpenseStepPage } from "./commercial/CommercialIncomeExpenseStepPage";
import { CommercialIntroStepPage } from "./commercial/CommercialIntroStepPage";
import { CommercialPicturesStepPage } from "./commercial/CommercialPicturesStepPage";
import { CommercialRentRollStepPage } from "./commercial/CommercialRentRollStepPage";
import { CommercialReviewStepPage } from "./commercial/CommercialReviewStepPage";
import { ResidentialIntroStepPage } from "./residential/ResidentialIntroStepPage";
import { ResidentialNeighborhoodWearStepPage } from "./residential/ResidentialNeighborhoodWearStepPage";
import { ResidentialReviewStepPage } from "./residential/ResidentialReviewStepPage";
import { ResidentialSympathySavingsStepPage } from "./residential/ResidentialSympathySavingsStepPage";
import { ResidentialWearAndTearStepPage } from "./residential/ResidentialWearAndTearStepPage";

export type ProtestStepperContentProps = {
  isResidential: boolean;
  /** 1-based index aligned with `PropertyStepperScreen` / view modal step state */
  currentStep: number;
  residentialSteps: StepDefinition[];
  commercialSteps: StepDefinition[];
  localSupportingDocuments: LocalSupportingDocumentItem[];
};

export const ProtestStepperContent = ({
  isResidential,
  currentStep,
  residentialSteps,
  commercialSteps,
  localSupportingDocuments,
}: ProtestStepperContentProps) => {
  if (isResidential) {
    switch (currentStep) {
      case 1:
        return <ResidentialIntroStepPage />;
      case 2:
        return <ResidentialWearAndTearStepPage />;
      case 3:
        return <ResidentialNeighborhoodWearStepPage />;
      case 4:
        return <ResidentialSympathySavingsStepPage />;
      case 5:
        return (
          <ResidentialReviewStepPage
            residentialSteps={residentialSteps}
            localSupportingDocuments={localSupportingDocuments}
          />
        );
      default:
        return null;
    }
  }

  switch (currentStep) {
    case 1:
      return <CommercialIntroStepPage />;
    case 2:
      return <CommercialPicturesStepPage />;
    case 3:
      return <CommercialRentRollStepPage />;
    case 4:
      return <CommercialIncomeExpenseStepPage />;
    case 5:
      return <CommercialFutureExpendituresStepPage />;
    case 6:
      return <CommercialAppraisalStepPage />;
    case 7:
      return (
        <CommercialReviewStepPage
          commercialSteps={commercialSteps}
          localSupportingDocuments={localSupportingDocuments}
        />
      );
    default:
      return null;
  }
};
